// Static media + copy used across the site. Product/price data comes from backend.

export const IMAGES = {
  // Brand product photography (user-supplied)
  hero: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/wmpezwr4_5.png",
  productLineup: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/wmpezwr4_5.png",
  matchdaySystem: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tvtxczbj_6.png",
  productFeatures: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tuixdrlb_7.png",
  matchday: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/6w72es2o_8.png",
  teamOrders: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/pdmhl0ez_10.png",
  aboutBrand: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/6w72es2o_8.png",
  gallery: [
    "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tvtxczbj_6.png",
    "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tuixdrlb_7.png",
    "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/6w72es2o_8.png",
  ],
};

export const BENEFITS = [
  {
    title: "Boot-Lock Grip",
    body: "Grip zones designed around football boot pressure points — heel, forefoot, arch.",
  },
  {
    title: "Close Boot Feel",
    body: "A thin-touch fit that keeps you connected to the boot. No bulk, no slip.",
  },
  {
    title: "Matchday Comfort",
    body: "Lightweight, breathable and built for repeated wear — 90 minutes and beyond.",
  },
  {
    title: "Colour-Matched Style",
    body: "Modern colourways designed to pair with boots and kits — not a fluorescent gym sock.",
  },
];

export const USPS = [
  {
    no: "01",
    title: "Boot-Lock Grip Map",
    body: "Grip placement focused on the heel, forefoot and pressure zones inside a football boot — not a generic gym pattern.",
  },
  {
    no: "02",
    title: "Thin-Touch Match Fit",
    body: "A close-fitting construction designed to avoid unnecessary bulk inside the boot.",
  },
  {
    no: "03",
    title: "Left/Right Anatomical Shape",
    body: "Designed to sit properly around the arch, heel and toe box for natural foot mechanics.",
  },
  {
    no: "04",
    title: "Ventilated Upper Panel",
    body: "Breathable upper-foot structure built for matchday comfort and sustained training output.",
  },
  {
    no: "05",
    title: "Grip-Life Standard",
    body: "Built to retain grip performance through repeated sessions, washes and rotations.",
  },
];

export const COLOUR_PAIRINGS = [
  { sock: "ice-white", boot: "White / Silver", kit: "Home whites" },
  { sock: "bootroom-blue", boot: "Black / Volt", kit: "Royal blue away" },
  { sock: "chalk-pink", boot: "Black", kit: "Off-trend third kit" },
  { sock: "volt-trim", boot: "Black / White", kit: "Monochrome training" },
  { sock: "stone", boot: "Tan / Brown", kit: "Earth-tone training fits" },
  { sock: "blackout-white", boot: "Any", kit: "Matchday basic" },
];

export const SOCIAL = [
  { handle: "@academy.proto", role: "Academy U18 — Manchester" },
  { handle: "@sundayleagueclub", role: "Sunday League — South London" },
  { handle: "@semipro.fc", role: "Semi-Pro — North-East" },
  { handle: "@pritchwear", role: "Brand" },
];

// Curated social grid (placeholder for future Instagram / TikTok integration)
export const SOCIAL_POSTS = [
  {
    platform: "instagram",
    handle: "@pritchwear",
    caption: "Matchday colour system — Series 01 lined up.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/wmpezwr4_5.png",
    likes: "2,148",
  },
  {
    platform: "tiktok",
    handle: "@pritchwear",
    caption: "Close boot feel. Clean matchday style.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/6w72es2o_8.png",
    likes: "14.2K",
  },
  {
    platform: "instagram",
    handle: "@pritchwear",
    caption: "Boot-Lock Grip Map · explained.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tuixdrlb_7.png",
    likes: "1,803",
  },
  {
    platform: "instagram",
    handle: "@academy.proto",
    caption: "Pre-match. Pritch on. Pitch ready.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/pdmhl0ez_10.png",
    likes: "962",
  },
  {
    platform: "tiktok",
    handle: "@pritchwear",
    caption: "Matchday Colour System — pick your pairing.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/tvtxczbj_6.png",
    likes: "8.4K",
  },
  {
    platform: "instagram",
    handle: "@sundayleagueclub",
    caption: "Team order delivered. Match day ready.",
    image: "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/pdmhl0ez_10.png",
    likes: "548",
  },
];
